import { inject, Pipe, PipeTransform } from '@angular/core';
import { ETimeNumericFormat, getLocalTimezone } from '@cf/core';
import { DateTime } from 'luxon';
import { Is12hFormat } from '../tokens';

@Pipe({
  name: 'currentTime',
  standalone: true,
})
export class CurrentTimePipe implements PipeTransform {
  is12hFormat = inject(Is12hFormat);

  luxonTimeFormat(timeFormat?: ETimeNumericFormat) {
    if (timeFormat) {
      if (timeFormat === ETimeNumericFormat.TIME_12) {
        return DateTime.TIME_SIMPLE;
      } else {
        return DateTime.TIME_24_SIMPLE;
      }
    }

    if (this.is12hFormat()) {
      return DateTime.TIME_SIMPLE;
    } else {
      return DateTime.TIME_24_SIMPLE;
    }
  }

  transform(timezone: string = getLocalTimezone(), timeFormat?: ETimeNumericFormat): string {
    return DateTime.local().setZone(timezone).toLocaleString(this.luxonTimeFormat(timeFormat));
  }
}
